module.exports = {
  VIEW: 'SURVEYS_VIEW',
  MANAGE_SETTINGS: 'SURVEYS_MANAGE_SETTINGS',
  ANALYTICS: 'SURVEYS_ANALYTICS',
  VIEW_TICKETS: 'CUSTOMER_CARE_VIEW',
  MANAGE_TICKETS: 'CUSTOMER_CARE_MANAGE_TICKETS'
}
